import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { backgroundColors } from 'lib/settings';

const Container = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
`;

const Label = styled.p`
	font-size: 12px;
	color: #9B9B9B;
	margin: 0 0 8px;
`;

const Option = styled.div`
	width: calc(20% - 16px);
	height: 40px;
	border: ${p => p.selected ? 5 : 1}px solid rgb(74, 144, 226, ${p => p.selected ? 1 : 0.3});
	border-radius: 2px;
	transition: border 0.1s ease-out;
	cursor: pointer;
	margin: 0 16px 8px 0;
`;

const validColors = { ...backgroundColors };

delete validColors.transparent;

const colors = Object.values(validColors);

class Color extends React.Component {
	state = {
	  color: this.props.color,
	}

	changeHandler = color => {
	  this.setState({ color });
	  this.props.updatePageSettingsHandler({
	    'background-color': color,
	  })
	}

	render() {
	  const c = colors.map(color => (
	    <Option
	      key={color}
	      color={color}
	      selected={this.state.color === color}
	      style={{ backgroundColor: color }}
	      onClick={() => this.changeHandler(color)}
	    />
	  ));

	  return (
	    <React.Fragment>
	      <Label>Sivun taustaväri</Label>
	      <Container>
	        { c }
	      </Container>
	    </React.Fragment>
	  )
	}
}

Color.propTypes = {
	updatePageSettingsHandler: PropTypes.func,
	color: PropTypes.string,
}

export default Color
